var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopMd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 558,
    height: 572,
    viewBox: "0 0 558 572",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M356.143 258.344V202.785",
    stroke: "white",
    strokeWidth: 2.88823,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1116 99.435L53.1921 76.0342",
    stroke: "white",
    strokeWidth: 0.577646,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7621 117.245L48.5894 113.349",
    stroke: "white",
    strokeWidth: 0.577646,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M225.509 331.944L357.212 256.924",
    stroke: "white",
    strokeWidth: 2.88823,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M205.937 173.159V117.601",
    stroke: "white",
    strokeWidth: 2.88823,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.21 121.091L12.21 6.17676",
    stroke: "white",
    strokeWidth: 1.22903,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3024 246.76L207.012 171.739",
    stroke: "white",
    strokeWidth: 2.88823,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1116 83.3598L53.1921 59.959",
    stroke: "white",
    strokeWidth: 0.577646,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1116 67.641L53.1921 44.2402",
    stroke: "white",
    strokeWidth: 0.577646,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1116 51.8657L53.1921 28.4648",
    stroke: "white",
    strokeWidth: 0.577646,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6804 95.6006L70.8652 126.585",
    stroke: "white",
    strokeWidth: 0.577646,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3297 69.7734L66.5947 87.7358",
    stroke: "white",
    strokeWidth: 0.577646,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2.82654 52.9336L20.2051 63.2513",
    stroke: "white",
    strokeWidth: 0.577646,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M348.087 423.605L527.016 529.825",
    stroke: "white",
    strokeWidth: 2.88823,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M338.15 428.577L517.079 534.796",
    stroke: "white",
    strokeWidth: 2.88823,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0998 126.584C9.08252 126.584 6.6306 124.157 6.61216 121.152C6.59373 118.147 9.02722 115.701 12.0445 115.683C15.1355 115.67 17.6366 118.135 17.6059 121.164C17.569 124.169 15.1171 126.584 12.0998 126.584Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M357.206 207.173C354.189 207.173 351.737 204.746 351.719 201.741C351.7 198.736 354.134 196.29 357.151 196.272C360.242 196.259 362.743 198.723 362.713 201.753C362.676 204.758 360.224 207.173 357.206 207.173Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M207 121.994C203.983 121.994 201.531 119.567 201.513 116.562C201.494 113.557 203.928 111.111 206.945 111.093C210.036 111.081 212.537 113.545 212.506 116.574C212.47 119.579 210.018 121.994 207 121.994Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2037 8.01972C10.1799 8.01972 8.53526 6.37778 8.5229 4.3451C8.51053 2.31242 10.1428 0.658009 12.1666 0.645539C14.2399 0.637225 15.9175 2.3041 15.8968 4.35341C15.8721 6.38609 14.2275 8.01972 12.2037 8.01972Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1863 29.6248C51.8835 29.6248 50.8204 28.574 50.8142 27.2712C50.8081 25.9746 51.8589 24.9114 53.1617 24.9053C54.5013 24.8992 55.5829 25.9684 55.5645 27.2773C55.5522 28.5801 54.489 29.6248 53.1801 29.6248H53.1863Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1863 46.5555C51.8835 46.5555 50.8204 45.5046 50.8142 44.2019C50.8081 42.9052 51.8589 41.8421 53.1617 41.836C54.5013 41.8298 55.5829 42.8991 55.5645 44.208C55.5522 45.5108 54.489 46.5555 53.1801 46.5555H53.1863Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1863 62.3191C51.8835 62.3191 50.8204 61.2683 50.8142 59.9655C50.8081 58.6689 51.8589 57.6058 53.1617 57.5996C54.5013 57.5935 55.5829 58.6628 55.5645 59.9717C55.5522 61.2744 54.489 62.3191 53.1801 62.3191H53.1863Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1863 78.3943C51.8835 78.3943 50.8204 77.3435 50.8142 76.0407C50.8081 74.7441 51.8589 73.681 53.1617 73.6748C54.5013 73.6687 55.5829 74.738 55.5645 76.0469C55.5522 77.3497 54.489 78.3943 53.1801 78.3943H53.1863Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7432 128.938C69.4404 128.938 68.3773 127.887 68.3711 126.585C68.365 125.288 69.4158 124.225 70.7186 124.219C72.0582 124.213 73.1398 125.282 73.1213 126.591C73.109 127.894 72.0459 128.938 70.737 128.938H70.7432Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2037 90.0945C65.901 90.0945 64.8378 89.0437 64.8317 87.7409C64.8255 86.4443 65.8764 85.3812 67.1791 85.375C68.5188 85.3689 69.6003 86.4381 69.5819 87.7471C69.5696 89.0498 68.5065 90.0945 67.1976 90.0945H67.2037Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M2.37206 55.2937C1.06929 55.2937 0.00617199 54.2429 2.68156e-05 52.9401C-0.00611836 51.6435 1.04471 50.5804 2.34748 50.5742C3.68713 50.5681 4.76868 51.6374 4.75025 52.9463C4.73796 54.2491 3.67484 55.2937 2.36592 55.2937H2.37206Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7562 119.598C40.4534 119.598 39.3903 118.548 39.3842 117.245C39.378 115.948 40.4289 114.885 41.7316 114.879C43.0713 114.873 44.1528 115.942 44.1344 117.251C44.1221 118.554 43.059 119.598 41.7501 119.598H41.7562Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M181.11 454.025C178.093 454.025 175.641 451.597 175.622 448.592C175.604 445.587 178.037 443.142 181.055 443.123C184.146 443.111 186.647 445.575 186.616 448.605C186.579 451.61 184.127 454.025 181.11 454.025Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M181.122 449.458V523.588L364.752 413.03L12.1116 208.838V122.701",
    stroke: "white",
    strokeWidth: 2.88823,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M504.021 558.099C481.714 558.099 463.567 539.805 463.438 517.19C463.309 494.576 481.314 476.141 503.634 476.024C526.512 475.907 545.021 494.478 544.763 517.277C544.505 539.921 526.358 558.105 504.021 558.099Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 8.18537,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M460.58 524.405H448.124V508.225H460.58",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M466.879 491.81L458.165 482.912L469.724 471.593L478.438 480.491",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M494.821 474.241V461.785H511.007V474.241",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M545.544 524.405H558V508.225H545.544",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M539.245 491.81L547.958 482.912L536.399 471.593L527.686 480.491",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M460.58 508.5H448.124V524.68H460.58",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M466.879 541.096L458.165 550L469.724 561.319L478.438 552.415",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M494.821 558.67V571.126H511.007V558.67",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M545.544 508.5H558V524.68H545.544",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M539.245 541.096L547.958 550L536.399 561.319L527.686 552.415",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M504.088 547.615C520.965 547.615 534.647 533.933 534.647 517.055C534.647 500.177 520.965 486.495 504.088 486.495C487.21 486.495 473.528 500.177 473.528 517.055C473.528 533.933 487.21 547.615 504.088 547.615Z",
    fill: "#716558",
    stroke: "white",
    strokeWidth: 0.940211,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopMd);
export default __webpack_public_path__ + "static/media/desktop-md.656996c2710bf23c79c33e69c8ab2000.svg";
export { ForwardRef as ReactComponent };